import { render } from "./MPSIVALeukocytes.vue?vue&type=template&id=158c155f&scoped=true"
import script from "./MPSIVALeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSIVALeukocytes.vue?vue&type=script&lang=js"

import "./MPSIVALeukocytes.vue?vue&type=style&index=0&id=158c155f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158c155f"]])

export default __exports__